// src/components/HydrogenInfrastructureLayer.jsx
import { useEffect } from 'react';
import { loadModules } from 'esri-loader';

const HydrogenInfrastructureLayer = ({ view }) => {
  useEffect(() => {
    if (!view || !view.map) return;

    let hydrogenTransmissionLayer, featureLayer, ieaLayer, geoportalLayer, groupLayer;

    loadModules([
      'esri/layers/FeatureLayer',
      'esri/layers/WMSLayer',
      'esri/layers/GroupLayer'
    ]).then(([FeatureLayer, WMSLayer, GroupLayer]) => {
      hydrogenTransmissionLayer = new FeatureLayer({
        url: 'https://services9.arcgis.com/xSsJeibXqRtsnmY7/ArcGIS/rest/services/Hydrogen_Infrastructure_Map_2024Q4_WFL1/FeatureServer/7',
        title: 'Hydrogen Transmission',
        fetchFeatures: true,
        defaultPopupTemplateEnabled: true
      });

      featureLayer = new FeatureLayer({
        url: 'https://services9.arcgis.com/xSsJeibXqRtsnmY7/ArcGIS/rest/services/Hydrogen_Infrastructure_Map_2024Q4_WFL1/FeatureServer/1',
        title: 'Demand and Production',
        fetchFeatures: true,
        defaultPopupTemplateEnabled: true
      });

      ieaLayer = new WMSLayer({
        title: 'IEA',
        url: 'https://portal.boom-h2-pipelines.com/geoserver/IEA/wms?',
        sublayers: [
          {
            title: 'Hydrogen Production Projects',
            name: 'IEA_Hydrogen_Production_Projects',
            queryable: true,
            popupEnabled: true
          }
        ]
      });

      groupLayer = new GroupLayer({
        title: 'Hydrogen Infrastructure',
        layers: [hydrogenTransmissionLayer, featureLayer, ieaLayer]
      });

      view.map.add(groupLayer);
    });

    return () => {
      if (groupLayer && view?.map) {
        view.map.remove(groupLayer);
      }
    };
  }, [view]);

  return null;
};

export default HydrogenInfrastructureLayer;
